import './instrument.js'
import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { ClerkProviderWrapper } from './components/ClerkProviderWrapper'
import ErrorBoundary from './components/ErrorBoundary'

createRoot(document.getElementById('root'), {
  onUncaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <ErrorBoundary>
    <ClerkProviderWrapper>
      <App />
    </ClerkProviderWrapper>
  </ErrorBoundary>,
)
